import { Code, Loader, Stack, Table, Text, Title } from '@mantine/core';

import { useYogaStyles } from '../../features/yoga-styles';
import { EmptyState, ErrorState } from '../../shared/ui';

/**
 * Справочник стилей — чтение и только чтение.
 *
 * Почему без кнопок «добавить» и «править»: в контракте `v0.7.0` у `/yoga-styles` один метод,
 * `GET`, и ни одного слуга вида `yoga-styles.*` в каталоге прав бэкенда. Набор пишется
 * миграцией. Панель бизнес-правил не изобретает и границы API не обходит (AD-A1, AD-A6),
 * поэтому экран говорит это словами, а не показывает действие, которое некуда отправить.
 */
export function YogaStylesPage() {
  const styles = useYogaStyles();

  return (
    <Stack gap="md">
      <Title order={2}>Справочник стилей</Title>

      {/* Пояснение — обычный текст, а не `Alert`: у Mantine `Alert` роль `alert`, и на
          экране оказались бы две, из которых только одна говорит об отказе. */}
      <Text size="sm" c="dimmed">
        Набор стилей закрыт: его пишет миграция бэкенда, эндпоинта для добавления и правки в
        контракте нет. Здесь видно, из чего выбирают учитель в профиле и практика в карточке.
      </Text>

      {styles.isError ? <ErrorState error={styles.error} /> : null}
      {styles.isPending ? <Loader /> : null}
      {styles.data?.length === 0 ? (
        <EmptyState>Стилей нет — весь набор выведен из обращения.</EmptyState>
      ) : null}

      {styles.data && styles.data.length > 0 ? (
        <Table striped>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Код</Table.Th>
              <Table.Th>Название</Table.Th>
              <Table.Th>Описание</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {styles.data.map((style) => (
              <Table.Tr key={style.slug}>
                {/* Код показан наравне с названием: именно его хранят профиль учителя и
                    практика, а названия контракт разрешает исправлять. */}
                <Table.Td>
                  <Code>{style.slug}</Code>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{style.nameRu}</Text>
                  <Text size="xs" c="dimmed">
                    {style.nameEn}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{style.descriptionRu}</Text>
                  <Text size="xs" c="dimmed">
                    {style.descriptionEn}
                  </Text>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      ) : null}
    </Stack>
  );
}
